<div class="centered">
  <form [formGroup]="relatorioForm" class="forms">
    <div class="panel">
      <div class="panel-title blue">Relatórios</div>

      <div class="panel-content row">
        <div class="form-group">
          <div class="inputs">
            <div>
              <label for="relatorio">Relatório</label>
              <saiba-mais
                [isPopoverOnHover]="true"
                [isPositionStatic]="true"
                [isSmall]="true"
                [texto]="'Escolha o relatório que deseja gerar.'"
              ></saiba-mais>
            </div>
            <select
              class="form-control"
              formControlName="idRelatorio"
              name="idRelatorio"
              required
              appShowErrorMessages
              requiredMessage="O campo Relatório é obrigatório"
            >
              <ng-container *ngIf="!isParceriaDell; else relatorioProducaoTemplate">
                <option value="" selected hidden>Selecione...</option>
                <option
                  *ngFor="let relatorio of relatorios"
                  value="{{ relatorio.id }}"
                >
                  {{ relatorio.nome }}
                </option>
              </ng-container>

              <ng-template #relatorioProducaoTemplate>
                <option [value]="13" selected>Relatório de Produção</option>
              </ng-template>
            </select>
          </div>
        </div>

        <div class="form-group">
          <div class="inputs">
            <div>
              <label for="dataInicial">Período</label>
              <saiba-mais
                [isPopoverOnHover]="true"
                [isPositionStatic]="true"
                [isSmall]="true"
                [texto]="
                  'Informe a data inicial e a data final do relatório, através de números do formato DD/MM/AAAA.'
                "
              ></saiba-mais>
            </div>
            <div class="row datas">
              <div class="col-sm-6">
                <input
                  class="form-control"
                  type="text"
                  mask-number
                  [mask]="'00/00/0000'"
                  placeholder="00/00/0000"
                  [dateCheck]="relatorioForm.get('dataInicial').value"
                  [dateFormat]="'DDMMYYYY'"
                  [dateMax]="relatorioForm.get('dataFinal').value"
                  [dateCheckOneMonthMin]="relatorioForm.get('dataFinal').value"
                  dateMessage="Data inválida!"
                  dateRangeMessage="Data inicial deve ser menor que a final"
                  dateRangeMonthMessage="Período máximo permitido é de 6 meses"
                  required
                  appShowErrorMessages
                  requiredMessage="Data inical é obrigatório"
                  formControlName="dataInicial"
                  name="dataInicial"
                />
              </div>
              <div class="col-sm-6">
                <input
                  class="form-control"
                  type="text"
                  mask-number
                  [mask]="'00/00/0000'"
                  placeholder="00/00/0000"
                  [dateCheck]="relatorioForm.get('dataFinal').value"
                  [dateFormat]="'DDMMYYYY'"
                  [dateMin]="relatorioForm.get('dataInicial').value"
                  [dateCheckOneMonth]="relatorioForm.get('dataInicial').value"
                  dateMessage="Data inválida!"
                  dateRangeMessage="Data final deve ser maior que a inicial"
                  dateRangeMonthMessage="Período máximo permitido é de 6 meses"
                  required
                  appShowErrorMessages
                  requiredMessage="Data final é obrigatório"
                  formControlName="dataFinal"
                  name="dataFinal"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="form-group" *ngIf="!isParceriaDell">
          <div class="inputs">
            <div>
              <label for="loja">Loja</label>
              <saiba-mais
                [isPopoverOnHover]="true"
                [isPositionStatic]="true"
                [isSmall]="true"
                [texto]="'Escolha a loja que deseja gerar o relatório'"
              ></saiba-mais>
            </div>
            <select
              class="form-control"
              formControlName="lojista"
              name="lojista"
              required
              appShowErrorMessages
              requiredMessage="O campo Loja é obrigatório"
            >
              <option value="" selected hidden>
                Selecione a loja que deseja visualizar no relatório...
              </option>
              <option [value]="0" *ngIf="exibeTodasFiliais">Todas</option>
              <option *ngFor="let lojista of lojistas" value="{{ lojista.id }}">
                {{ lojista.nomeFantasia }}
              </option>
            </select>
          </div>
        </div>

        <div class="form-group" *ngIf="isFabrica || isParceriaDell">
          <div class="inputs">
            <div>
              <label for="status-pagamento">Status Pagamento</label>
              <saiba-mais
                [isPopoverOnHover]="true"
                [isPositionStatic]="true"
                [isSmall]="true"
                texto="Escolha o Status Pagamento que deseja gerar o relatório"
              ></saiba-mais>
            </div>

            <select
              class="form-control"
              formControlName="statusPagamento"
              name="statusPagamento"
              appShowErrorMessages
              requiredMessage="O campo Status Pagamento é obrigatório"
            >
              <option value="" selected hidden>
                Selecione o status de pagamento que deseja visualizar no
                relatório...
              </option>
              <option [value]="statusPagamento.TODOS">Todos</option>
              <option [value]="statusPagamento.PENDENTE">Pgto Pendente</option>
              <option [value]="statusPagamento.REALIZADO">Pgto Realizado</option>
            </select>
          </div>
        </div>

        <div class="gerar-relatorio">
          <button
            class="btn"
            (click)="onClickGerarRelatorio(0, 50)"
            [disabled]="!relatorioForm.valid"
          >
            Gerar Relatório

            <img
              src="assets/images/icons/arrow-right.png"
              width="24"
              alt="gerar relatório"
            />
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<app-production
  *ngIf="dadosRelatorio"
  [filtros]="relatorioRequest"
  [relatorios]="dadosRelatorio"
  [page]="page"
  [totais]="totais"
  [detalhes]="clicouGerar"
  [isFabrica]="isFabrica"
  [isParceriaDell]="isParceriaDell"
  [isCessao]="dadosRelatorio[0]?.cessao"
  (detalhesEvent)="changeDetalhes($event)"
  (paginationEvent)="changePage($event)"
>
</app-production>
<app-loader-circles *ngIf="showLoader"></app-loader-circles>
